import artifact from '$houdini/artifacts/UpdateVehicleAttachment'
import { MutationStore } from '../runtime/stores/mutation'

export class UpdateVehicleAttachmentStore extends MutationStore {
	constructor() {
		super({
			artifact,
		})
	}
}
